// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606170422/js/" + chunkId + "." + {"44":"f342061b","225":"a1d07577","481":"0502279a","486":"73548118","770":"0df0b79e"}[chunkId] + ".0.35647949540036905.chunk.js";
};